// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"44d527385b9c6f6749ed","655":"b9e0e0a39ac64925312c"}[chunkId] + ".js";
};